var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.pages),function(page){return _c('PageImage',{key:page.id,attrs:{"page":page,"header":_vm.page_header(page)}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }